var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMark2CircleBold(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0EABA9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2C7.832 2 2 7.832 2 15s5.832 13 13 13 13-5.832 13-13S22.168 2 15 2zm0 24C8.935 26 4 21.065 4 15S8.935 4 15 4s11 4.935 11 11-4.935 11-11 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.485 9.126a1 1 0 0 0-1.359.388l-4.356 7.841-3.063-3.062a1 1 0 1 0-1.414 1.414l4 4a1.002 1.002 0 0 0 1.581-.222l5-9a1 1 0 0 0-.389-1.359z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark2CircleBold);
export default __webpack_public_path__ + "static/media/check_mark_2_circle_BOLD.43bd64054a9e1892e0b50374333f5d8c.svg";
export { ForwardRef as ReactComponent };